import { render, staticRenderFns } from "./OpenHours.vue?vue&type=template&id=4eb838d9&scoped=true"
import script from "./OpenHours.vue?vue&type=script&lang=js"
export * from "./OpenHours.vue?vue&type=script&lang=js"
import style0 from "./OpenHours.vue?vue&type=style&index=0&id=4eb838d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb838d9",
  null
  
)

export default component.exports